





































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { AttributeMixin } from '@/mixins';
import { SearchMixin } from '@acgn/herm/src/mixins';
import { AcgnTargetEdit } from '@/components';
import { DatePicker } from 'element-ui';
import dayjs from 'dayjs';
import moment from 'moment';
import { openUrl } from '@/util';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
  AcgnPermission,
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const StatisticAction = namespace('desk/statistic').Action;
const StaffAction = namespace('desk/staff').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
const StaffGetter = namespace('desk/staff').Getter;

interface SearchType {
  // 项目搜索字段
  project_name?: string; // 漫画名称
  page?: number; // 当前页码
  approve_start_time?: string | null;
  approve_end_time?: string | null;
  setlle_start_time?: string | null;
  setlle_end_time?: string | null;
  user_name?: string | null;
  status?: number | null;
  price?: number | null;
  settle_user_name?: string | null;
}

// 组件申明
@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton,
    AcgnTargetEdit,
    [DatePicker.name]: DatePicker,
  },
  mixins: [AttributeMixin, SearchMixin],
})
export default class AcgnStatisticProjectLinkSettle extends Vue {
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: '' }) public cancelSettleCode: string; // 取消结算权限码
  @Prop({ default: '' }) public settleCode: string; // 结算权限码
  @Prop({ default: '' }) public auth_code: string; // 提交结算权限码
  @StatisticAction private getLinkSetlle: any; // 获取环节结算
  @StatisticAction private setLinkSettle: any; // 设置环节结算
  @StaffAction private getTargetStaffList: any; // 获取部门成员列表
  @StatisticGetter private loadings: any; // 员工loading
  @StaffGetter private targetStaffList: any; // 员工列表

  private searchForm: SearchType = {
    // 头部筛选项
    project_name: '',
    page: 1,
    approve_start_time: moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD'),
    approve_end_time: moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD'),
    setlle_start_time: null,
    setlle_end_time: null,
    user_name: null,
    status: null,
    price: null,
    settle_user_name: null,
  };

  private pickerOptions: any = {
    shortcuts: [
      {
        text: '今天',
        onClick: (picker: any) => {
          const s = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '昨天',
        onClick: (picker: any) => {
          const s = moment()
            .add(-1, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          const e = moment()
            .add(-1, 'days')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '前天',
        onClick: (picker: any) => {
          const s = moment()
            .add(-2, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          const e = moment()
            .add(-2, 'days')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '本周',
        onClick: (picker: any) => {
          const s = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '上周',
        onClick: (picker: any) => {
          const week = moment().week(moment().week() - 1);
          const s = week.startOf('week').format('YYYY-MM-DD HH:mm:ss');
          const e = week.endOf('week').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '本月',
        onClick: (picker: any) => {
          const s = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '上月',
        onClick: (picker: any) => {
          const month = moment().month(moment().month() - 1);
          const s = month.startOf('month').format('YYYY-MM-DD HH:mm:ss');
          const e = month.endOf('month').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '过去7天',
        onClick: (picker: any) => {
          const s = moment()
            .add(-7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          const e = moment()
            .add(-1, 'days')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '过去30天',
        onClick: (picker: any) => {
          const s = moment()
            .add(-30, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          const e = moment()
            .add(-1, 'days')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '过去90天',
        onClick: (picker: any) => {
          const s = moment()
            .add(-90, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          const e = moment()
            .add(-1, 'days')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        },
      },
      {
        text: '全部',
        onClick: (picker: any) => {
          picker.$emit('pick', [
            '1970-01-01',
            moment().format('YYYY-MM-DD HH:mm:ss'),
          ]);
        },
      },
    ],
  };

  private staffs: any = [];
  private timeApproveRange: any = [
    moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD HH:mm:ss'),
  ];
  private timeSetlleRange: any = [];

  private pageConfig: any = {
    // 分页数据
    total: 0,
    currentPage: 1,
  };

  private selectRows: any = [];

  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        type: 'selection',
        width: 48,
        prop: 'link_id',
      },
      {
        label: '画手',
        width: 80,
        prop: 'user_name',
      },
      {
        label: '项目',
        prop: 'project_name',
      },
      {
        minWidth: 100,
        label: '环节',
        prop: 'link_name',
      },
      {
        label: '结算状态',
        prop: 'status',
        width: 70,
        render: (h: any, { row }: any) => (this as any).renderStatus(row),
      },
      {
        label: '件数',
        width: 80,
        prop: 'cell_number',
      },
      {
        label: '单价',
        width: 80,
        prop: 'price',
      },
      {
        label: '总价',
        width: 100,
        prop: 'all_price',
      },
      {
        label: '审批完成时间',
        prop: 'finish_time',
      },
      {
        label: '结算时间',
        prop: 'setlle_time',
      },
      {
        label: '结算人',
        width: 80,
        prop: 'settle_user_name',
      },
    ],
    data: [],
  };

  private get isCanSetTartget() {
    if (this.selectRows.length === 0) {
      return false;
    }
    return this.selectRows.every((item: any) => item.status === 1);
  }

  private get isCanEditTartget() {
    if (this.selectRows.length === 0) {
      return false;
    }

    // 如果不全是已设定目标的，不允许
    const re = this.selectRows.every(
      (item: any) => item.schedule.target_num > 0,
    );
    if (!re) {
      return false;
    }

    let filterObj: any = {};
    // 如果周期不一致，不允许修改
    this.selectRows.map((item: any) => {
      filterObj[item.schedule.target_period] = 1;
    });
    if (Object.keys(filterObj).length > 1) {
      return false;
    }

    // 如果环节不一致，也不允许修改
    filterObj = {};
    this.selectRows.map((item: any) => {
      filterObj[item.schedule.target_type] = 1;
    });
    if (Object.keys(filterObj).length > 1) {
      return false;
    }

    return true;
  }

  private renderStatus(row: any) {
    const info = row.status === 1 ? '已结算' : row.status === 2 ? '待结算' : '未结算';
    return <span>{`${info}`}</span>;
  }

  private async created() {
    // const cacheForm: any = this.$getFormCache();
    // let project_id: any = (this as any).$route.params.project_id;
    // if (project_id) {
    //   project_id = project_id - 0;
    // }
    // this.searchForm = { ...this.searchForm, ...cacheForm };
    if (this.searchForm.page) {
      // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
    await this.remoteStaff();
    // this.search();
  }

  private async remoteStaff() {
    const options = {
      page: 1,
      size: 100,
    };
    const targetStaffs = await this.getTargetStaffList(options);
    const { result, paging } = this.targetStaffList;
    this.staffs = result.list.filter((item: any) => item.user_name);
  }

  private renderTarget(row: any) {
    const schedule = row.schedule;
    const info =
      schedule.target_num === 0
        ? '未设定目标'
        : `${schedule.target_type === 1 ? '环节数' : '件数'}:
     ${schedule.finish_num}/${schedule.target_num}`;
    return <span>{`${schedule.period}${info}`}</span>;
  }

  // 刷新当前页
  private reloadList() {
    this.initSearh({ page: this.pageConfig.currentPage });
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      page,
      size: 30,
    };

    const { result } = await this.getLinkSetlle(options);
    const pager = result.pager;
    tableConfig.data = result.list;
    pageConfig.currentPage = pager.page;
    pageConfig.pageSize = pager.page_size;
    pageConfig.total = pager.total_count;

    const { page_size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private handleSelectionChange(val: object[]) {
    this.selectRows = val;
  }

  private changeApproveTimeFrame(val: any) {
    this.searchForm.approve_start_time = val ? val[0] : '';
    this.searchForm.approve_end_time = val ? val[1] : '';
  }

  private changeSetlleTimeFrame(val: any) {
    this.searchForm.setlle_start_time = val ? val[0] : '';
    this.searchForm.setlle_end_time = val ? val[1] : '';
  }

  private selectStaffStutasChange() {}
  private selectSettleStutasChange() {}

  // 取消结算
  private async cancelSettle() {
    if (this.selectRows.length === 0) {
      return;
    }
    try {
      const doRows = this.selectRows.filter((item: any) => item.status === 1 || item.status === 2);
      if (doRows.length === 0) {
        this.$message.success('没有可取消结算的项');
        return;
      }
      const data = {
        status: 0,
        link_ids: this.selectRows.map((item: any) => item.link_id).join(),
      };
      await this.setLinkSettle(data);
      this.$message.success('操作成功');
      this.reloadList();
    } catch (ex) {
      this.$message.error(this.$language.error);
    }
  }
  // 确认结算
  private async doSettle() {
    if (this.selectRows.length === 0) {
      return;
    }

    try {
      const doRows = this.selectRows.filter((item: any) => item.status === 0 || item.status === 2);
      if (doRows.length === 0) {
        this.$message.success('没有可确认结算的项');
        return;
      }
      const data = {
        status: 1,
        link_ids: doRows.map((item: any) => item.link_id).join(),
      };
      await this.setLinkSettle(data);
      this.$message.success('操作成功');
      this.reloadList();
    } catch (ex) {
      this.$message.error(this.$language.error);
    }
  }

  // 提交结算
  private async submitSettle() {
    if (this.selectRows.length === 0) {
      return;
    }

    try {
      const doRows = this.selectRows.filter((item: any) => item.status === 0);
      if (doRows.length === 0) {
        this.$message.success('没有可提交结算的项');
        return;
      }
      const data = {
        status: 2,
        link_ids: doRows.map((item: any) => item.link_id).join(),
      };
      await this.setLinkSettle(data);
      this.$message.success('操作成功');
      this.reloadList();
    } catch (ex) {
      this.$message.error(this.$language.error);
    }
  }

  private getSearchOptions() {
    return {
      ...filterEmpty(this.searchForm),
      page: 1,
      size: 10000,
    };
  }

  private exportExcel() {
    openUrl(`/api/v1/link/getlinksetlle?export=1`, this.getSearchOptions());
  }
}
